<template>
  <div>
    <v-text-field 
      prepend-icon="attach_file" 
      @click:prepend="onFocus"
      v-model="filename" 
      single-line
      :label="src ? filename : $t('choose') + '...' | cap" 
      :disabled="disabled"
      readonly
      ref="fileTextField"
      @click.native="onFocus"
      :append-icon="filename ? 'delete' : ''"
      @click:append="reset"
    ></v-text-field>
    <input 
      type="file" 
      :accept="accept"
      multiple="false" 
      :disabled="disabled"
      ref="fileInput" 
      @change="onFileChange">
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String]
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'Choisir...'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filename: '',
      src: null
    }
  },
  watch: {
    value (v) {
      this.filename = v
    }
  },
  mounted () {
    this.filename = this.value
  },

  methods: {
    getFormData (files) {
      const data = new FormData()
      for (let file in files) {
        if (typeof file === 'object') {
          data.append('data', file, file.name) // currently only one file at a time
        } else {
          data.append('data', file)
        }
      }
      return data
    },
    onFocus () {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange ($event) {
      const files = $event.target.files || $event.dataTransfer.files
      const form = this.getFormData(files)
      if (files) {
        if (files.length > 0) {
          this.filename = [...files].map(file => file.name).join(', ')
        } else {
          // this.filename = null
        }
      } else {
        this.filename = $event.target.value.split('\\').pop()
      }
      this.$emit('input', this.filename)
      this.$emit('formData', form)
      var input = $event.target
      if (input.files && input.files[0]) {
        var reader = new window.FileReader()
        reader.onload = (e) => {
          this.src = e.target.result
          this.$emit('change', this.src)
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    reset () {
      this.filename = ''
      this.src = null
      this.$emit('change', this.src)
    }
  }
}
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzFileSelector.vue